import { DesktopNotificationDetails } from '@weave/schema-gen-ts/dist/schemas/notification/v1/notification_api.pb';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { useQueryClient } from 'react-query';
import { TaskCenterQueries } from '@frontend/api-task-center';
import { useTaskCenterNotification } from '@frontend/notifications';
import { useWebsocketEventSubscription } from '@frontend/websocket';

interface UseNotificationsProps {
  onViewNotification: (notificationPayload: DesktopNotificationDetails['taskAlert']) => void;
}

export const useNotifications = ({ onViewNotification }: UseNotificationsProps) => {
  const queryClient = useQueryClient();

  const { create, remove } = useTaskCenterNotification({
    onView: async (notification) => {
      onViewNotification(notification.payload);
      remove(notification.id);
    },
  });

  // Weave's WS subscription for Task Center notification
  useWebsocketEventSubscription(NotificationType.TASK, async (payload) => {
    // Invalidating query so that once received a notification we refetch the latest data
    await queryClient.invalidateQueries(TaskCenterQueries.queryEndpointKeys.tasksList);

    create({
      id: String(payload.id),
      payload: payload.params,
      timestamp: Date.now(),
      type: 'task-center',
      state: {
        paused: true,
        status: 'unread',
      },
    });
  });
};
